export * from './SelectedProductsFloatingCounter.types';
export { default as SelectedProductsFloatingCounter } from './SelectedProductsFloatingCounter';
